// Quote a single CSV field and neutralise spreadsheet formula injection.
//
// A field beginning with `=`, `+`, `-`, `@`, a tab, or a carriage return is
// treated as a formula by Excel/Sheets/LibreOffice, so author-controlled text
// (e.g. a resource or unit title) could execute on open. We prefix such a value
// with a single quote so the spreadsheet renders it as literal text, then apply
// the usual RFC 4180 quoting when the value contains a comma, quote, or line break.
export function escapeCsvValue(value: string): string {
  const neutralised = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;

  if (
    neutralised.includes(',') ||
    neutralised.includes('"') ||
    neutralised.includes('\n') ||
    neutralised.includes('\r')
  ) {
    return `"${neutralised.replace(/"/g, '""')}"`;
  }

  return neutralised;
}
